import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { employeeCostManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const employeeManagementRouteMetadata: IRouteMetadataObj<
  typeof employeeCostManagementRoutesObj
> = {
  list: {
    title: "costManagement.index.title",
    description: "empty",
    lazy: () => import("@pages/costManagement/employeeCost/table/page"),
    mode: "index",
    type: "main",
    icon: "MoneyDollarCircleLine",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "costManagement.employeeCost.create.title",
    description: "empty",
    lazy: () => import("@/pages/costManagement/employeeCost/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "costManagement.employeeCost.edit.title",
    description: "empty",
    lazy: () => import("@/pages/costManagement/employeeCost/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  paymentHistory: {
    title: "costManagement.employeeCost.paymentHistory.title",
    description: "empty",
    lazy: () =>
      import("@pages/costManagement/employeeCost/paymentHistory/table/page"),
    mode: "index",
    type: "inner",
    icon: "CalendarCheckLine",
    breadcrumbs: [],
    permission,
  },
};

export const employeeCostManagementRoutes = createRoute<
  typeof employeeCostManagementRoutesObj
>(employeeCostManagementRoutesObj, employeeManagementRouteMetadata);
